import React, { useContext } from 'react';
import NavBar from '../components/NavBar';
import SubscriptionForm from '../components/SubscriptionForm';
import { LanguageContext } from '../LanguageContext';
import '../App.css';

function ComingSoon() {
  const { t } = useContext(LanguageContext);

  return (
    <div>
      <NavBar />
      <div className="page-content">
        <h1>{t('comingsoon') || 'Coming Soon'}</h1>
        <div className="text-section" style={{ textAlign: 'center' }}>
          <p>
            {t('comingsoon_message') || 'This page is coming soon. Stay tuned!'}
          </p>
        </div>
      </div>
      {/* <SubscriptionForm /> */}
    </div>
  );
}

export default ComingSoon;
